var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_251_836",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1300,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_251_836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.73 1197.33C1012.7 1199.5 1009.23 1201.66 1006.2 1203.83C1002.73 1206 999.698 1208.16 996.231 1209.9C993.198 1211.63 990.598 1213.36 987.564 1215.1C987.131 1215.53 986.698 1215.53 986.264 1215.96C976.298 1222.03 965.898 1227.66 955.498 1232.86C952.464 1234.6 948.998 1236.33 945.964 1237.63C945.964 1237.63 945.531 1238.06 945.098 1238.06C941.631 1239.8 938.164 1241.53 934.698 1243.26C927.764 1246.73 920.398 1249.76 913.464 1252.8C909.998 1254.53 906.098 1255.83 902.631 1257.13C899.164 1258.43 895.264 1260.16 891.798 1261.46C888.331 1262.76 884.431 1264.5 880.964 1265.8C880.964 1265.8 880.964 1265.8 880.531 1265.8C877.064 1267.1 873.164 1268.4 869.698 1269.7C861.898 1272.3 853.664 1274.9 845.864 1277.5C843.264 1278.36 840.231 1279.23 837.631 1280.1C829.398 1282.7 821.164 1284.86 812.931 1286.6C809.898 1287.46 806.864 1287.9 803.398 1288.76C795.598 1290.5 787.364 1292.23 779.564 1293.96C777.831 1294.4 776.531 1294.4 774.798 1294.83C772.198 1295.26 769.164 1295.7 766.564 1296.13C762.664 1296.56 759.198 1297.43 755.298 1297.86C753.564 1298.3 751.831 1298.3 750.098 1298.73C747.931 1299.16 745.331 1299.6 742.731 1299.6C735.798 1300.46 728.431 1301.33 721.498 1302.2C719.331 1302.63 716.731 1302.63 714.564 1303.06H714.131C711.098 1303.5 708.064 1303.5 705.031 1303.93C701.998 1304.36 698.964 1304.36 695.931 1304.36C694.198 1304.36 692.031 1304.8 690.298 1304.8C686.831 1304.8 683.798 1305.23 680.764 1305.23C676.431 1305.23 672.531 1305.66 668.198 1305.66C663.864 1305.66 659.964 1305.66 655.631 1305.66C652.598 1305.66 649.564 1305.66 646.531 1305.66C464.098 1303.06 299.431 1225.5 182.431 1102.43C182.431 1102.43 182.431 1102 181.998 1102C195.431 1075.56 245.265 1027.9 297.265 988.464C363.131 938.631 456.298 907.864 456.298 907.864C456.298 907.864 517.398 897.898 744.031 945.131C916.931 981.531 990.598 1129.3 1015.73 1197.33Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.132 1065.16C783.032 1109.8 724.098 1136.23 624.865 1096.36C503.098 1046.96 456.298 907.864 456.298 907.864C449.798 808.198 434.632 722.831 434.632 722.831C575.465 710.698 741.865 875.364 741.865 875.364L760.932 956.831C762.665 963.764 766.132 969.831 771.332 974.164C780.432 989.764 798.198 1036.56 792.132 1065.16Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.331 974.598C688.565 970.264 627.465 958.131 562.031 840.698C617.498 889.664 682.931 908.298 751.831 916.964L760.931 956.831C762.665 964.198 766.131 970.264 771.331 974.598Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.498 452.431C950.298 488.831 954.198 518.298 932.964 615.364C911.731 712.431 952.464 809.498 850.198 898.331C781.298 958.131 660.831 969.398 564.631 903.964C532.131 881.864 502.231 851.098 477.965 810.798C458.898 779.164 436.798 749.264 412.098 721.964C377.865 684.698 336.698 609.731 357.065 477.131C389.998 261.331 603.631 236.631 729.731 260.465C855.831 284.298 921.264 356.231 942.498 452.431Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.797 621.864C527.797 621.864 514.364 556.864 451.097 564.664C396.497 571.598 377.431 702.464 501.364 738.864",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.465 679.498C497.465 679.498 481.865 669.531 483.598 652.198C486.198 631.831 483.598 619.264 474.065 615.364C450.231 605.398 445.465 633.131 446.331 636.598",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.097 721.531C828.097 721.531 844.564 722.398 860.164 703.764C868.831 693.364 876.197 680.364 871.431 676.464C866.664 672.131 788.231 684.264 783.031 694.664C777.831 705.064 808.164 721.531 828.097 721.531Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.098 575.931C841.098 575.931 841.965 617.098 868.398 663.031C880.098 683.398 862.331 716.764 823.765 722.398",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M606.232 743.631C630.883 743.631 650.866 727.14 650.866 706.798C650.866 686.455 630.883 669.964 606.232 669.964C581.582 669.964 561.599 686.455 561.599 706.798C561.599 727.14 581.582 743.631 606.232 743.631Z",
    fill: "#F2A5B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M926.03 670.831C924.73 695.098 925.164 718.931 923.43 742.764C904.364 738.431 890.497 724.131 890.497 707.231C890.497 689.031 905.664 674.298 926.03 670.831Z",
    fill: "#F2A5B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.88 829.399C389.88 829.399 430.18 819.866 447.08 818.566L452.28 865.799C452.713 865.366 390.313 841.533 389.88 829.399Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.62 1465.1H63.1489C63.1489 1465.1 69.6489 1264.03 135.516 1120.6C199.649 981.933 374.282 921.7 454.882 900.9C454.882 903.066 455.315 904.8 455.315 906.966C455.315 906.966 502.115 1046.07 623.882 1095.47C723.115 1135.77 782.049 1108.9 791.149 1064.27C796.782 1035.67 779.015 988.866 769.915 973.7C764.715 969.366 761.249 962.866 759.515 956.366L756.049 942.066C766.882 939.9 777.282 936.866 787.249 932.966C843.149 947.7 927.215 982.8 1026.45 1066C1138.68 1159.6 1158.62 1465.1 1158.62 1465.1Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.65 1465.1L258.15 1304.33",
    stroke: "white",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.25 1249.73C1034.25 1249.73 1021.25 1281.37 1025.15 1313C1029.05 1344.63 1040.31 1391 1024.28 1465.1",
    stroke: "white",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.515 1176.07C350.882 1106.73 290.648 965.9 290.648 965.9C290.648 965.9 328.348 942.5 346.115 918.233C356.948 903.5 454.448 886.6 454.448 886.6C456.182 905.233 454.448 886.6 455.748 906.966C455.748 906.966 502.548 1046.07 624.315 1095.47C723.548 1135.77 782.482 1108.9 791.582 1064.27C797.215 1035.67 779.448 988.866 770.348 973.7C765.148 969.366 761.682 962.866 759.948 956.366L756.482 942.066C781.182 936.866 804.582 927.333 824.948 914.766C825.815 916.066 826.248 917.366 826.682 918.666C835.782 940.766 863.515 960.7 863.515 960.7C921.582 1097.63 834.482 1246.7 590.515 1176.07Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.415 997.966C932.415 997.966 952.348 988.433 972.282 990.6C992.215 992.766 1087.11 1069.47 1096.21 1085.5C1105.75 1101.53 1105.31 1152.67 1094.05 1159.17C1083.21 1165.23 1076.28 1151.37 1076.28 1151.37C1076.28 1151.37 1084.51 1104.57 1075.41 1095.9C1066.31 1087.23 978.348 1013.57 975.315 1013.13C972.282 1012.7 955.815 1026.57 955.815 1026.57L932.415 997.966Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.647 987.133C277.647 987.133 238.647 970.666 221.747 973.266C204.847 975.866 117.314 1051.27 109.081 1084.63C100.847 1118 128.581 1178.23 128.581 1178.23L148.081 1147.47C148.081 1147.47 134.214 1101.53 138.547 1083.33C142.881 1065.13 212.214 1002.73 219.147 1002.73C226.081 1002.73 267.681 1021.37 267.681 1021.37L277.647 987.133Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.916 1011.83C499.516 1091.57 582.715 1197.73 721.815 1247.57C847.049 1292.63 839.249 1141.4 821.049 1050.83C696.249 1078.13 571.015 1080.3 457.916 1011.83Z",
    fill: "#443F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.047 1051.27C816.28 1027.43 810.647 1007.93 806.747 997.099C798.08 973.699 785.08 952.899 773.38 937.299C767.747 939.033 762.113 940.333 756.48 941.633L759.947 955.933C761.68 962.866 765.147 968.933 770.347 973.266C771.213 974.999 772.513 977.166 773.813 979.766C675.447 1017.9 559.313 967.633 559.313 967.633C524.213 965.899 526.813 1000.57 543.28 1041.73C480.88 982.366 455.747 906.966 455.747 906.966C454.88 893.966 454.013 881.399 452.713 868.833C452.713 868.833 420.647 886.599 426.28 926.466C428.88 943.366 438.847 974.999 458.347 1011.83C571.013 1080.3 696.247 1078.13 821.047 1051.27Z",
    fill: "#E26076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.88 829.399C389.88 829.399 490.847 876.199 572.313 897.866C580.113 900.033 586.18 906.966 587.046 915.199C590.08 944.666 598.313 1013.57 605.247 1040C614.347 1074.23 790.713 1248.43 792.446 1270.53C794.18 1292.63 614.347 1287.43 507.313 1159.17C399.847 1030.9 408.08 1007.5 408.08 1007.5C408.08 1007.5 389.88 884.433 389.88 829.399Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.448 875.767L898.182 887.467C906.848 890.933 911.182 900.9 908.148 910C895.582 948.133 864.382 1043.03 863.082 1075.97C861.348 1117.57 775.548 1384.93 775.548 1384.93C775.548 1384.93 723.115 1316.03 761.682 1248C792.015 1194.27 793.748 1079.43 790.715 1064.27C786.815 1044.33 770.348 997.533 761.248 968.067C756.482 952.033 755.615 942.067 755.615 942.067C755.615 942.067 815.415 932.1 870.448 875.767Z",
    fill: "#544646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.048 946.833C554.988 946.833 560.614 940.431 560.614 932.533C560.614 924.635 554.988 918.233 548.048 918.233C541.107 918.233 535.481 924.635 535.481 932.533C535.481 940.431 541.107 946.833 548.048 946.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.248 1211.17C716.614 1177.37 628.214 1097.2 601.348 1079.43C585.748 1069.03 568.848 1061.23 551.081 1055.6C438.414 1019.2 401.581 959.833 401.581 959.833L396.814 918.233",
    stroke: "#443F3F",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.614 1235C768.614 1235 758.214 1286.57 762.547 1311.7C766.88 1336.83 770.347 1411.8 770.347 1411.8",
    stroke: "#443F3F",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.215 973.7C888.215 973.7 866.981 1048.23 857.015 1077.7C846.615 1107.17 799.381 1166.1 786.381 1194.27",
    stroke: "#443F3F",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.447 1228.93C839.345 1228.93 845.747 1222.53 845.747 1214.63C845.747 1206.73 839.345 1200.33 831.447 1200.33C823.549 1200.33 817.147 1206.73 817.147 1214.63C817.147 1222.53 823.549 1228.93 831.447 1228.93Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.802 526.549C755.216 527.849 762.49 517.882 759.067 508.349C757.355 503.149 754.36 498.382 749.653 495.349C735.104 486.249 680.758 485.382 652.088 506.182C626.841 525.249 703.01 520.482 745.802 526.549Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.333 531.315C856.63 531.315 851.923 521.348 855.775 513.115C857.914 508.782 860.91 504.882 865.189 502.715C878.454 496.215 913.971 500.115 929.804 522.215C943.925 541.715 899.85 530.882 864.333 531.315Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.825 581.148C703.438 567.282 660.218 577.682 660.218 577.682",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.854 589.815C899.854 589.815 888.728 577.682 847.648 587.215",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.332 777.193C804.781 792.019 782.766 829.759 740.083 812.237C699.198 795.613 687.068 717.438 745.475 754.728C776.026 774.048 794.447 777.193 804.332 777.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.867 775.395C812.867 775.395 793.997 785.729 745.474 754.728C687.516 717.438 699.197 795.613 740.083 812.237C782.765 829.759 804.78 791.57 804.331 777.193",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.936 765.96C705.936 765.96 736.488 786.178 745.473 784.381C754.908 783.033 753.56 796.063 796.243 797.411",
    stroke: "#423232",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.818 447.316C941.518 440.816 939.785 433.883 937.618 427.383C935.451 420.883 930.251 415.249 923.318 413.949C900.785 410.049 871.318 433.016 840.118 428.683C740.885 415.249 682.385 361.949 589.218 397.916C493.018 435.183 547.618 590.316 527.251 614.149C523.785 602.016 506.885 552.616 451.418 559.549C398.985 566.049 379.052 687.383 487.385 728.983C486.518 752.816 443.618 775.349 408.951 733.749C374.285 692.149 304.952 584.249 351.752 426.516C398.552 268.783 610.451 186.449 807.618 266.616C841.418 280.483 861.785 314.716 891.251 320.349C1165.12 372.349 976.185 631.483 967.951 701.249C965.785 725.083 949.318 478.516 942.818 447.316Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.817 729.416C487.817 729.416 486.95 764.949 450.55 830.816C450.55 830.816 441.884 794.416 422.817 761.049C404.184 727.683 383.384 713.383 360.417 643.616C337.45 573.849 363.884 605.049 384.684 633.649C405.917 662.683 419.784 733.749 487.817 729.416Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.884 402.25C870.884 402.25 914.218 317.316 757.351 240.616C600.484 163.916 439.718 217.65 343.084 207.25C343.084 207.25 452.284 280.916 563.651 299.983C675.018 319.05 870.884 402.25 870.884 402.25Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.484 250.149C561.484 250.149 350.45 247.983 263.784 474.183C263.784 474.183 349.584 420.449 472.65 409.183C595.717 397.916 615.217 261.416 561.484 250.149Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.417 412.216C893.417 412.216 1026.45 365.416 943.684 253.183C847.917 124.049 539.384 174.316 539.384 174.316C539.384 174.316 650.75 203.783 697.117 268.349C743.05 333.349 857.884 439.949 893.417 412.216Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.217 420.45C797.217 420.45 709.684 373.65 656.384 419.15C589.65 476.349 606.984 757.149 606.984 757.149C606.984 757.149 528.55 615.449 529.85 482.416C531.15 349.383 592.25 316.016 656.384 321.65C720.517 327.283 788.984 399.65 797.217 420.45Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.916 429.549C847.916 429.549 690.617 293.916 682.383 533.549C682.383 533.549 632.55 483.283 672.85 369.316C713.15 255.349 839.25 346.349 847.916 429.549Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M747.932 670.912C747.932 670.912 707.198 696.479 661.265 696.045C615.332 695.612 609.698 659.645 609.265 640.145C609.265 640.145 615.332 668.312 643.065 678.712C670.365 689.112 747.932 670.912 747.932 670.912Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M878.8 666.145C878.8 666.145 888.766 678.278 902.2 686.945C911.3 693.012 923.433 686.512 923.433 675.678C923.867 675.678 898.3 676.978 878.8 666.145Z",
    fill: "#B7AEA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M763.967 548.279L636.567 675.679C646.534 681.745 658.667 684.779 670.8 683.045L731.467 675.245C749.667 672.645 766.567 663.545 779.567 648.379C784.767 642.745 787.8 634.945 788.233 626.712L790.4 583.812C791.267 565.179 779.567 549.579 763.967 548.279Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M763.967 548.279L642.2 537.012C621.834 535.279 604.5 553.912 604.5 577.312V614.145C604.5 641.012 617.5 663.979 636.567 675.679L763.967 548.279Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M941.631 543.945L865.364 553.912C855.397 555.212 848.031 569.512 848.897 585.978L850.197 624.545C850.631 631.912 852.364 638.845 855.397 644.045C860.597 652.712 867.097 659.212 874.031 663.545L964.597 572.978C962.864 555.645 952.897 542.645 941.631 543.945Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M874.465 663.979C878.365 666.145 881.832 667.879 886.165 668.745L923.865 676.112C945.965 680.445 965.465 651.412 965.465 613.712V580.779C965.465 578.179 965.465 576.012 965.031 573.845L874.465 663.979Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.967 548.279L642.2 537.012C621.834 535.279 604.5 553.912 604.5 577.312V614.145C604.5 655.745 635.7 687.812 670.8 683.045L731.467 675.245C749.667 672.645 766.567 663.545 779.567 648.378C784.767 642.745 787.8 634.945 788.234 626.712L790.4 583.812C791.267 565.179 779.567 549.579 763.967 548.279Z",
    stroke: "white",
    strokeWidth: 14.5456,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.798 554.345L942.065 544.378C954.631 542.645 965.464 559.545 965.464 580.778V613.712C965.464 650.978 945.964 680.012 923.864 676.112L886.165 668.745C874.898 666.578 864.065 657.912 856.265 644.478C853.231 639.278 851.065 632.345 851.065 624.978L849.765 586.412C848.465 569.945 855.831 555.645 865.798 554.345Z",
    stroke: "white",
    strokeWidth: 14.5456,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.5 581.645L504.4 579.479",
    stroke: "white",
    strokeWidth: 13.4786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.399 584.678C790.399 584.678 842.833 574.278 849.333 584.678",
    stroke: "white",
    strokeWidth: 14.5456,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy3);
export default __webpack_public_path__ + "static/media/Boy_3.3a0e5a458588a509e143a31df9515472.svg";
export { ForwardRef as ReactComponent };